import type { FC, ReactNode } from 'react'
import { useRef } from 'react'
import type { PopoverRootActions } from '@base-ui/react/popover'
import { Popover } from '@systemeio/components'
import { GifIcon } from '@systemeio/icons'
import { cn } from 'cn'
import type { GIFObject } from 'modules/attachments/api/tenor.types'
import { GifPickerPanel } from './gif-picker-panel'

interface GifPickerProps {
  className?: string
  onSelect: (gif: GIFObject) => void
  iconClassName?: string
}

export const GifPicker: FC<GifPickerProps> = ({
  onSelect,
  className,
  iconClassName,
}): ReactNode => {
  const actionsRef = useRef<PopoverRootActions | null>(null)

  return (
    <div className={cn('flex', className)}>
      <Popover.Root actionsRef={actionsRef}>
        <Popover.Trigger type="button" aria-label="Toggle GIF Picker">
          <GifIcon className={cn('size-6', iconClassName)} />
        </Popover.Trigger>
        <Popover.Portal>
          <Popover.Positioner
            side="top"
            sideOffset={10}
            collisionAvoidance={{ fallbackAxisSide: 'none' }}
          >
            <Popover.Popup className="z-30">
              <GifPickerPanel onSelect={onSelect} onClose={() => actionsRef.current?.close()} />
            </Popover.Popup>
          </Popover.Positioner>
        </Popover.Portal>
      </Popover.Root>
    </div>
  )
}
